import { inject, Injectable } from '@angular/core';
import { CULTURE_CONFIG, CultureConfig, Language } from '../models/language';
import { ContextService } from './context.service';
import { StorageService } from './storage.service';

export const LANGUAGE_KEY = 'language';
// Only used to set the language in other applications via Local Storage
export const CULTURE_KEY = 'culture';
@Injectable({
    providedIn: 'root',
})
export class CultureResolverService {
    private cultureConfig = inject<CultureConfig>(CULTURE_CONFIG);
    private storage = inject(StorageService);
    private context = inject(ContextService);

    private _startupLanguage?: Language;
    get startupLanguage(): Language {
        return this._startupLanguage || (this._startupLanguage = this.resolve());
    }
    readonly registeredLanguages: Language[] = this.cultureConfig.appLanguages;
    readonly defaultLanguage: Language = this.cultureConfig.fallbackLanguage;

    private resolve(): Language {
        return <Language>(this.retrieveFromContext() || this.retrieveFromLocalStorage() || this.cultureConfig.fallbackLanguage);
    }
    private retrieveFromContext(): string | null {
        return this.truthOrNull(this.context.language());
    }
    private retrieveFromLocalStorage(): string | null {
        return this.truthOrNull(this.storage.getItem(LANGUAGE_KEY));
    }
    private truthOrNull(lang: string | null): string | null {
        const allegedLang = lang ? lang.toLowerCase() : null;
        return this.cultureConfig.appLanguages.indexOf(allegedLang as Language) > -1 ? allegedLang : null;
    }
}
